
<template>

  <div class="lotti-service-module">

    <table class="lotti-service-info" style="position: initial;">
      <tr>
        <td class="lotti-service-info-title">Total Pensum</td>
        <td class="lotti-service-info-data">{{infoData.totalPensum}}</td>
      </tr>
      <tr>
        <td class="lotti-service-info-title">Total WochenSoll</td>
        <td class="lotti-service-info-data">{{infoData.weeklyMinutes}}</td>
      </tr>
      <tr>
        <td class="lotti-service-info-title">Anzahl Logopädinnen</td>
        <td class="lotti-service-info-data">{{infoData.therapistCount}}</td>
      </tr>
      <tr>
        <td class="lotti-service-info-title">Wohngemeinden</td>
        <td class="lotti-service-info-data">
          {{infoData.linkedServices.length}}
          <el-button
              type="secondary"
              icon="el-icon-edit"
              size="mini"
              class="lotti-service-micro-button"
              @click="dialogFormVisible = true">
          </el-button>
        </td>
      </tr>
    </table>

    <el-dialog :visible.sync="dialogFormVisible" title="Wohngemeinden" width="40%">
      <el-form :model="infoData">
        <el-form-item label="Auswahl der zugehörigen Gemeinden" prop="linkedServices">
          <el-select
              style="width: 100%;"
              v-model="infoData.linkedServices"
              :multiple-limit="10"
              type="textarea"
              :rows="2"
              clearable
              filterable
              multiple
              placeholder="Keine Gemeinde ausgewählt"
              reserve-keyword>
            <el-option
                v-for="item in allServiceList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Abbrechen</el-button>
        <el-button type="primary" @click="storeLinkedServices" :loading="isUpdating">Speichern</el-button>
      </span>
    </el-dialog>

  </div>

</template>

<script>
import auth from '../../auth.js';
import Vue, {VueInstance} from "../../main";
import notification from "../../Helpers/NotificationHelper";

export default {

  data() {
    return {
      auth: auth,

      infoData: {
        therapistCount: null,
        linkedServices: [],
        totalPensum: '%',
        weeklyMinutes: 'min'
      },

      dialogFormVisible: false,
      isUpdating: false,

      servicesLoading: false,
      linkedServiceOptions: [],
      allServiceList: []
    }
  },

  methods: {

    getTotalPensum() {

      Vue.http.get(
          'api/v1/service/get-total-pensum'
      ).then(response => {
        this.infoData.therapistCount = response.data.therapistCount;
        this.infoData.linkedServices = response.data.linkedServices.map(item => {
          return item.id
        });
        this.infoData.totalPensum = response.data.totalPensum + '%';
        this.infoData.weeklyMinutes = response.data.weeklyMinutes + ' min';
      }, response => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },

    //get all services that are
    //a) not in use / linked to other service or
    //b) linked to service of lead therapist
    getAllFreeOrMyServices() {

      Vue.http.get(
          'api/v1/service/get-all-free-or-my'
      ).then(response => {
        this.allServiceList = response.data.map(item => {
          return {value: item.id, label: item.name}
        });
      }, response => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },

    storeLinkedServices() {

      //show loading indicator on save button
      this.isUpdating = true;

      Vue.http.post(
          'api/v1/service/update-lead-therapist',
          {
            serviceIds: this.infoData.linkedServices.join(),
          }
      ).then(response => {

        //show success msg
        notification.showSuccess(this, 'Zugewiesene Gemeinden wurden erfolgreich gespeichert');

        //stop loading indicator
        this.isUpdating = false;

        //hide dialog
        this.dialogFormVisible = false

      }, error => {
        notification.showError(this, 'Zugewiesene Gemeinden konnten nicht gespeichert werden');

        //stop loading indicator
        this.isUpdating = false;

        //hide dialog
        // this.dialogFormVisible = false
      })
    },
  },

  beforeMount() {

    //get all free services or those linked to this service
    this.getAllFreeOrMyServices();

    //get pensum data of therapist
    this.getTotalPensum();
  },

  mounted() {
    //event fired from therapistManagement.vue when this component should update its data
    VueInstance.$on('updatedTherapists', this.getTotalPensum);
  },

  beforeDestroy() {
    VueInstance.$off('updatedTherapists', this.getTotalPensum);
  },
}

</script>